export const fmtCurrency = (val: number | undefined) => val?.toLocaleString("en-IE", { minimumFractionDigits: 2 }) ?? "";
